/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const ServiceEngagement = ({
    engagementDetails,
    serviceInternalExternalActivity,
}: Partial<{
    serviceInternalExternalActivity: string;
    engagementDetails: string;
}>) => (
    <>
        {engagementDetails && (
            <Row>
                <ValueCell label="Details" value={engagementDetails} />
            </Row>
        )}
        {serviceInternalExternalActivity && (
            <Row>
                <ValueCell single label="Internal or External" value={serviceInternalExternalActivity} />
            </Row>
        )}
    </>
);

export default ServiceEngagement;
